import api from '../api';
import { TTransactionsDTO } from '../../lib/DBModels';
import { TTransactionsRequestProps } from './transactions.types';

export const punterTransactions = '/punter/transactions';
export const queryTransactions = (params: TTransactionsRequestProps) =>
  api
    .get<TTransactionsDTO>(punterTransactions, { params })
    .then((res) => res.data);
